import { StackedBarchartModule } from '../stacked-bar-chart/stackedbarchart.module';
import { StationOccupancyDashboardComponent } from './station-occupancy-dashboard.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CommonTranslationModule } from '@sdbn/common';
import { MaterialModule, ApplicationClientCommonModule } from '@sdbn/appclient';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MaterialModule,
    SharedModule,
    StackedBarchartModule,
    CommonTranslationModule,
    ApplicationClientCommonModule
  ],
  declarations: [
    StationOccupancyDashboardComponent]
})
export class StationOccupancyDashboardModule { }
